export function formatTicketNumber(ticketNumber, ticketRevision) {
    if (typeof ticketRevision === 'string' && ticketRevision.length > 0) {
        return ticketNumber + '-' + ticketRevision;
    } else {
        return ticketNumber;
    }
}
